import React from 'react';
import PropTypes from 'prop-types';

const User = ({ color }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M9,7.85714286 C10.8971429,7.85714286 12.4171429,6.32571429 12.4171429,4.42857143 C12.4171429,2.53142857 10.8971429,1 9,1 C7.10285714,1 5.57142857,2.53142857 5.57142857,4.42857143 C5.57142857,6.32571429 7.10285714,7.85714286 9,7.85714286 Z M9,10.1428571 C6.33714286,10.1428571 1,11.48 1,14.1428571 L1,17 L17,17 L17,14.1428571 C17,11.48 11.6628571,10.1428571 9,10.1428571 Z"
                id="user-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/18px-(All-icons)/Owner"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#user-path-1" />
            </mask>
            <use id="Mask" fill={color} xlinkHref="#user-path-1" className="icon-color" />
        </g>
    </svg>
);

User.defaultProps = {
    color: '#8C949C',
};

User.propTypes = {
    color: PropTypes.string,
};

export default User;
